<template>
    <NavbarMain />

    <PresentationAnnouncements v-if="currentLanguage === 'translated'" :photo="first_section_image_translated" :title="first_section_title_translated"
        :content="first_section_content_translated" :content-link="second_section_button_content_translated" :link-x="second_section_button_link_translated" />
    <PresentationAnnouncements v-else :photo="first_section_image_en" :title="first_section_title_en"
        :content="first_section_content_en" :content-link="second_section_button_content_en" :link-x="second_section_button_link_en" />

    <!-- <div class="columns-4-section">
        <CtaSectionExtern v-if="currentLanguage === 'pl'" :content="second_section_title_pl"
            :content-link="second_section_button_content_pl" :link-x="second_section_button_link_pl" />
        <CtaSectionExtern v-else :content="second_section_title_en" :content-link="second_section_button_content_en"
            :link-x="second_section_button_link_en" />
    </div> -->

    <WidePhotoComponent v-if="currentLanguage === 'translated'" :photo="third_section_image_translated" :content="third_section_content_translated" />
    <WidePhotoComponent v-else :photo="third_section_image_en" :content="third_section_content_en" />

    <FooterPage />
</template>

<script>
import axios from 'axios';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';
import PresentationAnnouncements from '@/components/PresentationAnnouncements.vue';

export default {
    components: {
    NavbarMain,
    FooterPage,
    WidePhotoComponent,
    PresentationAnnouncements
},
    data() {
        return {
            announcementData: {
                items_translated: [{ first_section_image: '', first_section_title: '', first_section_content: '', second_section_title: '', second_section_button_content: '', second_section_button_link: '', third_section_image: '', third_section_content: '' }],
                items_en: [{ first_section_image: '', first_section_title: '', first_section_content: '', second_section_title: '', second_section_button_content: '', second_section_button_link: '', third_section_image: '', third_section_content: '' }]
            },
        

            first_section_image_translated: '',
            first_section_title_translated: '',
            first_section_content_translated: '',
            second_section_title_translated: '',
            second_section_button_content_translated: '',
            second_section_button_link_translated: '',
            third_section_image_translated: '',
            third_section_content_translated: '',

            first_section_image_en: '',
            first_section_title_en: '',
            first_section_content_en: '',
            second_section_title_en: '',
            second_section_button_content_en: '',
            second_section_button_link_en: '',
            third_section_image_en: '',
            third_section_content_en: '',
        }
    },
    computed: {
        currentLanguage() {
            return this.$store.getters.getCurrentLanguage;
        },
    },
    created() {
        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/announcements-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.announcementData = response.data || { items_translated: [], items_en: [] };
                console.log(this.announcementData)
                if (this.announcementData.items_translated[0].active === true) {
                    this.first_section_title_translated = this.announcementData.items_translated[0].first_section_title;
                    this.first_section_content_translated = this.announcementData.items_translated[0].first_section_content;
                    this.first_section_image_translated =   this.announcementData.items_translated[0].first_section_image;
                    this.second_section_title_translated = this.announcementData.items_translated[0].second_section_button_title;
                    this.second_section_button_content_translated = this.announcementData.items_translated[0].second_section_button_content;
                    this.second_section_button_link_translated = this.announcementData.items_translated[0].second_section_button_link;
                    this.third_section_image_translated =   this.announcementData.items_translated[0].third_section_image;
                    this.third_section_content_translated = this.announcementData.items_translated[0].third_section_content;
                }
                console.log(this.first_section_image_translated)

                if (this.announcementData.items_en[0].active === true) {
                    this.first_section_title_en = this.announcementData.items_en[0].first_section_title;
                    this.first_section_content_en = this.announcementData.items_en[0].first_section_content;
                    this.first_section_image_en =   this.announcementData.items_en[0].first_section_image;
                    this.second_section_title_en = this.announcementData.items_en[0].second_section_button_title;
                    this.second_section_button_content_en = this.announcementData.items_en[0].second_section_button_content;
                    this.second_section_button_link_en = this.announcementData.items_en[0].second_section_button_link;
                    this.third_section_image_en =   this.announcementData.items_en[0].third_section_image;
                    this.third_section_content_en = this.announcementData.items_en[0].third_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching Announcements data:', error);
            });


        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    }
}
</script>

<style>
.columns-4-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    justify-content: center;
    /* Center the columns horizontally */
    align-items: center;
    gap: 10px;
    padding-left: 3rem;
}

@media all and (max-width: 850px) {
    .columns-4-section {
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
    }
}
</style>